import { SoundChannel } from "./SoundChannel";
import { PAL } from "../platform/PlatformAdapters";
import { Pool } from "../utils/Pool";
export class WebAudioChannel extends SoundChannel {
    get duration() {
        if (this._buffer)
            return this._buffer.duration;
        else
            return 0;
    }
    onPlay(url) {
        PAL.media.audioDataCache.get(url, this.onLoaded, this);
    }
    onPlayAgain() {
        this.reset();
        this.startPlay(false);
    }
    onStop() {
        this.reset();
        this._buffer = null;
    }
    onPause() {
        this.reset();
    }
    onResume() {
        this.startPlay(true);
    }
    onVolumeChanged() {
        if (!this._sourceNode)
            return;
        let volume = this._muted ? 0 : this._volume;
        if (this._gainNode.gain.setTargetAtTime)
            this._gainNode.gain.setTargetAtTime(volume, PAL.media.audioCtx.currentTime, 0.001);
        else
            this._gainNode.gain.value = volume;
    }
    onMuted() {
        this.onVolumeChanged();
    }
    onLoaded(buffer) {
        if (!this._started)
            return;
        this._buffer = buffer;
        if (!buffer || this.startTime >= this.duration) {
            this.stop();
            return;
        }
        this._loaded = true;
        if (this._paused)
            return;
        this.startPlay(false);
    }
    startPlay(isResuming) {
        let ctx = PAL.media.audioCtx;
        let state = ctx.state;
        if (state === "closed") {
            this.stop();
            return;
        }
        if (state != null && state !== "running") {
            let resumeTime = isResuming ? this._pauseTime : this.startTime;
            this._startTime = 0;
            PAL.media.resumeUntilGotFocus(this);
            this._pauseTime = resumeTime;
            return;
        }
        this._gainNode = WebAudioChannel.gainNodePool.take();
        let sourceNode = this._sourceNode = ctx.createBufferSource();
        sourceNode.buffer = this._buffer;
        sourceNode.connect(this._gainNode);
        sourceNode.onended = () => this.onPlayEnd();
        if (sourceNode.playbackRate) {
            if (sourceNode.playbackRate.setTargetAtTime)
                sourceNode.playbackRate.setTargetAtTime(this.playbackRate, ctx.currentTime, 0.001);
            else
                sourceNode.playbackRate.value = this.playbackRate;
        }
        sourceNode.loop = this.loops === 0;
        sourceNode.loopStart = this.startTime;
        sourceNode.loopEnd = this._buffer.duration;
        this._gainNode.gain.value = this._muted ? 0 : this._volume;
        sourceNode.start(0, isResuming ? this._pauseTime : this.startTime);
        this._startTime = performance.now();
    }
    reset() {
        if (!this._sourceNode)
            return;
        let sourceNode = this._sourceNode;
        if (sourceNode.stop)
            sourceNode.stop(0);
        else
            sourceNode.noteOff(0);
        sourceNode.disconnect();
        sourceNode.onended = null;
        this._sourceNode = null;
        WebAudioChannel.gainNodePool.recover(this._gainNode);
        this._gainNode = null;
    }
}
WebAudioChannel.gainNodePool = Pool.createPool2(() => createGainNode(), node => initGainNode(node), node => resetGainNode(node));
function createGainNode() {
    let node;
    if (PAL.media.audioCtx.createGain)
        node = PAL.media.audioCtx.createGain();
    else
        node = PAL.media.audioCtx.createGainNode();
    return node;
}
function initGainNode(node) {
    node.connect(PAL.media.audioCtx.destination);
}
function resetGainNode(node) {
    node.disconnect();
}
